import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../pages/home'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/productInfo',
    name: 'productInfo',
    component: () => import('../pages/productInfo')
  },
  {
    path: '/productList',
    name: 'productList',
    component: () => import('../pages/productList')
  },
  {
    path: '/application1',
    name: 'application1',
    component: () => import('../pages/application')
  },
  {
    path: '/application2',
    name: 'application2',
    component: () => import('../pages/application/index2.vue')
  },
  {
    path: '/application3',
    name: 'application3',
    component: () => import('../pages/application/index3.vue')
  },
  {
    path: '/application4',
    name: 'application4',
    component: () => import('../pages/application/index4.vue')
  },
  {
    path: '/application5',
    name: 'application5',
    component: () => import('../pages/application/index5.vue')
  },
  {
    path: '/application6',
    name: 'application6',
    component: () => import('../pages/application/index6.vue')
  },
  {
    path: '/qualificationCertificate',
    name: 'qualificationCertificate',
    component: () => import('../pages/qualificationCertificate')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../pages/aboutUs')
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import('../pages/newsList')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../pages/news')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/models',
    name: 'models',
    component: () => import('../pages/models')
  },
  {
    path: '/testNews',
    name: 'testNews',
    component: () => import('../pages/testNews')
  },
  {
    path: '/testNewsInfo',
    name: 'testNewsInfo',
    component: () => import('../pages/testNewsInfo')
  },
  {
    path: '/laboratory',
    name: 'laboratory',
    component: () => import('../pages/laboratory')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../pages/test')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router
